import styled from 'styled-components';

const PRODUCT_LOGO_SIZE_IN_PX = 32;
const PRODUCT_GLYPH_SIZE_IN_PX = 20;

/**
 * Same row as the drawer pages (PageContainer + StyledLink of SideBarContent).
 */
export const ProductRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  height: 48px;
  width: 100%;
  padding: 8px 0;

  border-bottom: solid 1px ${({ theme }) => theme.colors.greys.darker};
  color: ${({ theme }) => theme.colors.white};
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.green.light};
  }
`;

/**
 * Same size and radius as the InPulse logo of the sidebar it replaces.
 */
export const ProductLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: ${PRODUCT_LOGO_SIZE_IN_PX}px;
  height: ${PRODUCT_LOGO_SIZE_IN_PX}px;
  border-radius: 4px;

  background-color: ${({ brandColor }) => brandColor};
`;

/**
 * The MOS product icons are monochrome currentColor SVGs, which an <img> cannot recolor;
 * using them as a mask paints them white on the brand color.
 */
export const ProductGlyph = styled.span`
  width: ${PRODUCT_GLYPH_SIZE_IN_PX}px;
  height: ${PRODUCT_GLYPH_SIZE_IN_PX}px;

  background-color: ${({ theme }) => theme.colors.white};
  -webkit-mask: url(${({ iconUrl }) => iconUrl}) center / contain no-repeat;
  mask: url(${({ iconUrl }) => iconUrl}) center / contain no-repeat;
`;
